module.exports = __webpack_public_path__ + "static/media/business-small.30ae4eb6.webp";